import Papa from 'papaparse';
import moment from 'moment';

/**
 * Export and download array of objects as .CSV file.
 *
 * @param {object} data
 * @param {string} reportName
 * @param {array} columns
 */
const exportAsCsv = (data, reportName, columns) => {
    // If columns given, filter
    if(columns && Array.isArray(columns)) {
        data = data.map(item => {
            let mappedItem = { ...item };
            let row = {};

            for ( const column of columns ) {
                const { key, label, customFormat } = column;

                if (customFormat) {
                    mappedItem[key] = customFormat(mappedItem[key]);
                }

                if (`/${key}/`.match('time') && mappedItem[key]) {
                    mappedItem[key] = moment(mappedItem[key]).format('DD.MM.YYYY - HH:mm:ss');
                }

                row[label] = mappedItem[key] || '';
            }

            return row;
        });
    }

    let csv = "\uFEFF" + Papa.unparse(data);
    let csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    let csvURL =  null;
    let isIE = false || !!document.documentMode;
    let tempLink = document.createElement('a');

    if (navigator.msSaveOrOpenBlob && isIE) {
        csvURL = navigator.msSaveOrOpenBlob(csvData, reportName + '.csv');
        tempLink.href = window.location.href.substring(window.location.href.lastIndexOf("/") + 1);
    } else {
        csvURL = window.URL.createObjectURL(csvData);
        tempLink.href = csvURL;
    }
    tempLink.setAttribute('download', reportName + '.csv');
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
}


export default exportAsCsv;